// services/frontend/src/components/composed/CharacterCounter/CharacterCounter.tsx

import { Text } from '../../atoms/Text/Text';

export interface CharacterCounterProps {
  current: number;
  min: number;
  max: number;
  showValidation?: boolean;
}

export function CharacterCounter({ current, min, max, showValidation = false }: CharacterCounterProps) {
  const remaining = max - current;
  const isUnderMin = current < min;
  const isOverMax = current > max;
  const isWarning = remaining < 100;

  return (
    <div className="flex items-center justify-between text-sm">
      {/* Validation messages */}
      <div role="alert" aria-live="polite">
        {showValidation && isUnderMin && (
          <Text variant="muted" className="text-danger">
            At least {min - current} more characters required
          </Text>
        )}
        {showValidation && isOverMax && (
          <Text variant="muted" className="text-danger">
            {current - max} characters over limit
          </Text>
        )}
      </div>

      {/* Character count */}
      <Text
        variant="muted"
        className={isWarning ? 'text-danger' : ''}
        aria-label={`Character count: ${current} of ${max}`}
      >
        {current} / {max}
      </Text>
    </div>
  );
}
